import React from 'react';
import { LoaderWrapper } from './Loader.styles';

const Loader = () => {
  return (
    <LoaderWrapper>
      <img src='/images/Loader.gif' style={{ width: '50px', height: '50px' }} />
    </LoaderWrapper>
  );
};

export default Loader;
